// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GggTh","newExpiryDate":"styles_newExpiryDate__1qfiw","footer":"styles_footer__3QMkN"};